export default __webpack_public_path__ + "983e949d0b27296eea79674a63759848.png";